import {
  CoverPageInviteTokenQuery,
  InvitationType,
  RegistrationRoleEnum
} from "@pathwright/graphql-client/src/generated"
import type { RegistrationAccessRow } from "../registration/access"

const roleRank: Record<RegistrationRoleEnum, number> = {
  observer: -1,
  student: 5,
  moderator: 10,
  teacher: 15,
  editor: 20
}

export type CoverPageInvitation = { cohortId: number; role: number }

export function getInvitationForCohort(
  invitation: CoverPageInviteTokenQuery["invitationToken"],
  cohortId: number | null | undefined
): CoverPageInvitation | null {
  return invitation?.invite_type === InvitationType.Cohort &&
    invitation.cohort?.id != null &&
    invitation.cohort.id === cohortId
    ? { cohortId: invitation.cohort.id, role: invitation.role }
    : null
}

/**
 * The caller supplies resumable RegistrationAccess rows, excluding archived/expired
 * access. Membership in another cohort, or a lower role in this cohort, does not
 * satisfy the invitation. Equal/higher roles can Resume without accepting again.
 *
 * A higher-role invitation must reach RegisterFlow rather than being swallowed by
 * the Cover Page's Resume gate. This does not implement role upgrades: the legacy
 * register-store TODO and backend already-enrolled restriction remain DEV-2335.
 */
export function inviteRequiresAcceptance(
  invitation: CoverPageInvitation,
  accesses: RegistrationAccessRow[]
) {
  return !accesses.some(
    (access) =>
      access.cohort_id === invitation.cohortId &&
      roleRank[access.role] >= invitation.role
  )
}
